import { BaseUrl } from '../ApiUrl'
import AXIOS_SERVICE from '../../utils/AxiosUtil'

const SetupStockService = () => {}

SetupStockService.InsertSetupStock = async(payload)=> {  
  return await AXIOS_SERVICE('post', `${BaseUrl}/stock/setup`, payload)
}

 export default SetupStockService